export const getProducts = (state) => state.products
export const getProduct = (state) => (hash_id) => { return state.products.filter((product) => { return product.hash_id == hash_id })[0] }
export const getStoreProductSaleElements = (state) => (id) => { return state.storeProductSaleElements[id] || [] }
export const getProductSaleElements = (state) => state.product_sale_elements
export const getProductSaleElementsByCategories = (state) => state.product_sale_elements_by_categories
export const getLots = (state) => state.lots